import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
    CardActionArea,
} from "@mui/material";
import PaymentsIcon from "@mui/icons-material/Payments";
import PercentIcon from "@mui/icons-material/Percent";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SchoolIcon from "@mui/icons-material/School"; // example loan icon
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { moneyFormat } from "../utils/utils";

const LoanProductCard = ({ loan, isSelected = false, onPress }) => {
    return (
        <Card

            sx={{
                borderRadius: 3,
                borderColor: isSelected ? "goldenrod" : "gray-600",
                borderWidth: 2,
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                "&:hover": { boxShadow: "0 6px 24px rgba(0,0,0,0.08)" },
            }}
        >
            <CardActionArea onClick={onPress}>
                <CardContent>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Box display="flex" alignItems="center">
                            <SchoolIcon sx={{ color: "primary.main", mr: 1 }} />
                            <Typography variant="h6" fontWeight="600">
                                {loan.product_name}
                            </Typography>
                        </Box>
                        <CheckCircleIcon sx={{ color: isSelected ? "goldenrod" : "gray" }} />
                    </Box>

                    <Typography variant="body2" color="text.secondary" mb={2}>
                        {loan.description}
                    </Typography>

                    <Divider sx={{ mb: 2 }} />

                    {/* Loan Details */}
                    <Box display="flex" alignItems="center" mb={1}>
                        <PaymentsIcon sx={{ color: "green", mr: 1 }} />
                        <Typography variant="body2">
                            <strong>Amount Range:</strong> ₦{moneyFormat(loan.min_amount)} - ₦{moneyFormat(loan.max_amount)}
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mb={1}>
                        <PercentIcon sx={{ color: "orange", mr: 1 }} />
                        <Typography variant="body2">
                            <strong>Interest Rate:</strong> {loan.interest_rate_pct}%
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center">
                        <SyncAltIcon sx={{ color: "purple", mr: 1 }} />
                        <Typography variant="body2">
                            <strong>Interest Type:</strong> {loan.management_fee_type}
                        </Typography>
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default LoanProductCard;
